import AOS from 'aos';
import 'aos/dist/aos.css'; // Import AOS styles

const initializeAOS = () => {
  // Initialize AOS with your preferred options
  AOS.init({
    duration: 1000, // Animation duration
    easing: 'ease-in-out', // Easing function
    once: true, // Trigger animations only once
    offset: 120, // Offset from the top of the screen to trigger animation
  });
};

export default initializeAOS;
